import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/soluciones-software/*")({
  head: () => buildRouteHead("/es/servicios/soluciones-software/*", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/software-solutions-services", replace: true });
  },
});
